var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var IconTextEvent;
(function (IconTextEvent) {
    IconTextEvent["Clicked"] = "Clicked";
})(IconTextEvent || (IconTextEvent = {}));
var IconText = (function (_super) {
    __extends(IconText, _super);
    function IconText(scene, config) {
        var _this = _super.call(this, scene, config.x, config.y) || this;
        _this.config = config;
        _this.iconImage = _this.scene.make.image(__assign({}, _this.config.imageConfig));
        _this.text = _this.scene.make.bitmapText(__assign({}, _this.config.textConfig));
        _this.add([
            _this.iconImage,
            _this.text,
        ]);
        _this.repositionAfterChange();
        _this.updateSize();
        _this.bindEventHandlers();
        _this.scene.add.existing(_this);
        return _this;
    }
    IconText.prototype.setIconTexture = function (key, frame) {
        this.iconImage.setTexture(key, frame);
        this.repositionAfterChange();
        this.updateSize();
        return this;
    };
    IconText.prototype.setIconScale = function (x, y) {
        this.iconImage.setScale(x, y);
        this.repositionAfterChange();
        this.updateSize();
    };
    IconText.prototype.setTextTint = function (value) {
        this.text.setTint(value);
        return this;
    };
    IconText.prototype.clearTextTint = function () {
        this.text.clearTint();
    };
    IconText.prototype.setTint = function (value) {
        this.iconImage.setTint(value);
        this.text.setTint(value);
        return this;
    };
    IconText.prototype.clearTint = function () {
        this.iconImage.clearTint();
        this.text.clearTint();
    };
    IconText.prototype.setIconFlipX = function (value) {
        this.iconImage.setFlipX(value);
        return this;
    };
    IconText.prototype.setIconFlipY = function (value) {
        this.iconImage.setFlipY(value);
        return this;
    };
    IconText.prototype.setText = function (text) {
        this.text.setText(text.toString());
        this.repositionAfterChange();
        this.updateSize();
    };
    IconText.prototype.getText = function () {
        return this.text.text;
    };
    IconText.prototype.bindEventHandlers = function () {
        var _this = this;
        this.on('pointerup', function () {
            _this.emit(IconTextEvent.Clicked);
        });
    };
    IconText.prototype.updateSize = function () {
        var _a;
        var width = this.text.width + this.spacing + this.iconImage.displayWidth;
        var height = Math.max(this.text.height, this.iconImage.displayHeight);
        var x = Math.min(this.text.x - (this.text.width * this.text.originX), this.iconImage.getLeftCenter().x);
        var y = 0;
        if (!((_a = this.input) === null || _a === void 0 ? void 0 : _a.hitArea)) {
            this.setInteractive({
                hitArea: new Phaser.Geom.Rectangle(x + width / 2, y, width, height),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                cursor: this.config.changeCursorIcon ? "pointer" : '',
            });
        }
        else {
            this.input.hitArea.setTo(x + width / 2, y, width, height);
        }
        this.setSize(width, height);
    };
    IconText.prototype.repositionAfterChange = function () {
        this.text.setPosition(this.textOffset.x, this.textOffset.y);
        this.iconImage.setPosition(this.imageOffset.x, this.imageOffset.y);
        var side = this.config.textFirst ? 1 : -1;
        if (this.config.vertical) {
            this.text.setOrigin(0.5, this.config.textFirst ? 1 : 0);
            var halfImageHeight = this.iconImage.displayHeight * 0.5;
            this.text.x = this.iconImage.x;
            this.text.y = (halfImageHeight + this.spacing) * (this.config.textFirst ? -1 : 1);
            if (this.config.centered) {
                var totalHeight = this.iconImage.displayHeight + this.text.height + this.spacing;
                this.iconImage.y = (totalHeight - this.iconImage.displayHeight) * 0.5 * side;
                this.text.y = this.iconImage.y - (this.iconImage.displayHeight * 0.5 + this.spacing) * side;
                return;
            }
            return;
        }
        this.text.setOrigin(this.config.textFirst ? 1 : 0, 0.5);
        if (this.config.centered) {
            var totalWidth = this.iconImage.displayWidth + this.text.width + this.spacing;
            this.iconImage.x = (totalWidth - this.iconImage.displayWidth) * 0.5 * side;
            this.text.x = this.iconImage.x - (this.iconImage.displayWidth * 0.5 + this.spacing) * side;
            return;
        }
        this.text.x = this.iconImage.x - (this.iconImage.displayWidth * 0.5 + this.spacing) * side;
    };
    Object.defineProperty(IconText.prototype, "textOffset", {
        get: function () {
            var _a, _b;
            return {
                x: (_a = this.config.textConfig.x) !== null && _a !== void 0 ? _a : 0,
                y: (_b = this.config.textConfig.y) !== null && _b !== void 0 ? _b : 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IconText.prototype, "imageOffset", {
        get: function () {
            var _a, _b;
            return {
                x: (_a = this.config.imageConfig.x) !== null && _a !== void 0 ? _a : 0,
                y: (_b = this.config.imageConfig.y) !== null && _b !== void 0 ? _b : 0,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IconText.prototype, "spacing", {
        get: function () {
            var _a;
            return (_a = this.config.spacing) !== null && _a !== void 0 ? _a : 0;
        },
        enumerable: false,
        configurable: true
    });
    return IconText;
}(Phaser.GameObjects.Container));
export { IconText };
